var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        selectedPeople: _vm.selection,
        hasFab: !!_vm.selection.length,
        fabLoading: _vm.composeEmailLoading,
        page: "/dashboard",
        pageTitle: "Membership Prices",
        backLink: "/dashboard/reports",
      },
      on: {
        eventProgress: function ($event) {
          ;[
            (_vm.progress = $event.progress),
            (_vm.progressError = $event.error),
          ]
        },
        fabAction: function ($event) {
          _vm.selection.length ? _vm.emailUsers() : null
        },
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      dateSelection: false,
                      absolute: "",
                      filter: "",
                      reportUrl: "/dashboard/reports/membership-prices/",
                    },
                    on: {
                      search: function ($event) {
                        ;[(_vm.search = $event), _vm.expand()]
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "filterItem",
                        fn: function () {
                          return [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          href: `${_vm.$page.url}?csv=true`,
                                          text: "",
                                          outlined: "",
                                          rounded: "",
                                          block: "",
                                          color: "dark",
                                        },
                                      },
                                      [
                                        _vm._v("Download as CSV"),
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", right: "" } },
                                          [_vm._v("download")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.membershipPrices,
                      search: _vm.search,
                      "show-select": "",
                      groupBy: "groupColumn",
                      groupDesc: "",
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      "custom-sort": _vm.customSort,
                    },
                    on: {
                      "item-selected": function ($event) {
                        return _vm.handleItemSelect($event)
                      },
                      "current-items": function ($event) {
                        return _vm.collapse()
                      },
                      "toggle-select-all": function ($event) {
                        return _vm.expand($event)
                      },
                      "click:row": function ($event) {
                        return _vm.$log($event.id)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ group, items, isOpen, toggle }) {
                            return [
                              _c("th", { attrs: { colspan: "1" } }, [
                                _c(
                                  "tr",
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "align-center flex-nowrap",
                                        attrs: { "no-gutters": "" },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-3",
                                            on: {
                                              click: function ($event) {
                                                ;[
                                                  toggle(),
                                                  isOpen
                                                    ? (_vm.selection =
                                                        _vm.selection.filter(
                                                          (e) =>
                                                            e.price_id !== group
                                                        ))
                                                    : null,
                                                ]
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                isOpen ? "remove" : "add"
                                              ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { colspan: "1" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "soli-grey text-subtitle-2 font-weight-bold whitespace-nowrap",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(items.length) +
                                        " Membership(s)\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { colspan: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "soli-grey text-subtitle-2 font-weight-bold whitespace-nowrap flex-nowrap flex",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(`${items[0].name}`) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { colspan: "1" } }, [
                                _c("tr", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "soli-grey text-subtitle-2 font-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(items[0].format_amount) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { colspan: "1" } }),
                              _vm._v(" "),
                              _c("th", { attrs: { colspan: "1" } }, [
                                _c(
                                  "tr",
                                  { staticClass: "justify-end flex" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          text: "",
                                          rounded: "",
                                          color: "accent",
                                        },
                                        on: {
                                          click: function ($event) {
                                            ;[
                                              isOpen ? null : toggle(),
                                              (_vm.selection = items),
                                            ]
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Select All\n                                    "
                                        ),
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", right: "" } },
                                          [_vm._v("check_box")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          text: "",
                                          color: "error",
                                          rounded: "",
                                          disabled:
                                            !_vm.editable ||
                                            !_vm.uniquePriceIds.includes(group),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditPrice(group)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Edit\n                                    "
                                        ),
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", right: "" } },
                                          [_vm._v("edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: `item.student.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center py-2 soli-grey",
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "my-0",
                                      staticStyle: { float: "left" },
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: item.student.profile_photo_path
                                            ? `/api/image-service/40x40/${item.student.profile_photo_path}`
                                            : item.student.profile_photo_url,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.student.id}/account`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(item.student.name) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        [
                                          item.student.recipient
                                            ? _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "secondary",
                                                  },
                                                },
                                                [_vm._v("handshake")]
                                              )
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.student.email) +
                                              "\n                                "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              item.lesson ??
                                                "No Scheduled Lessons"
                                            )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-nowrap whitespace-nowrap",
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.tags`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "flex gap-1" },
                                _vm._l(item.tags, function (tag) {
                                  return _c(
                                    "v-chip",
                                    {
                                      key: tag.id,
                                      staticClass:
                                        "white--text font-weight-bold text-capitalize",
                                      attrs: {
                                        color: tag.color,
                                        "x-small": "",
                                      },
                                    },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                }),
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.selection,
                      callback: function ($$v) {
                        _vm.selection = $$v
                      },
                      expression: "selection",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.editPrice && _vm.selection.length
        ? _c("BatchUpdateMembershipPrice", {
            attrs: {
              membershipPrice: _vm.editPrice,
              purchaseOptions: _vm.selection,
              errors: _vm.errors,
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.editPrice = null))
              },
              success: function ($event) {
                ;[
                  (_vm.$refs.layout.showMessage = true),
                  (_vm.selection = []),
                  (_vm.loading = true),
                  (_vm.editPrice = null),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading && !_vm.progressError
        ? _c(
            "SoliChoice",
            {
              attrs: {
                title: _vm.progress < 100 ? "Updating Memberships" : "Complete",
                subtitle:
                  _vm.progress < 100
                    ? "Processing Your Request"
                    : "Memberships Updated Successfully!",
                permanent: "",
                disabled1: _vm.progress < 100,
                button1: _vm.progress < 100 ? "Please Wait" : "Close",
              },
              on: {
                reset: function ($event) {
                  return _vm.handleComplete()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "px-3 pb-3" },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      "buffer-value": _vm.progress,
                      stream: "",
                      rounded: "",
                      color: "secondary",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.progressError
        ? _c("SoliChoice", {
            attrs: {
              title: "Contact kyle@musicologie.com",
              subtitle: `Something went wrong. ${_vm.progressError}`,
              button1: "Close",
              warning: "",
            },
            on: {
              reset: function ($event) {
                return _vm.handleComplete()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.composeEmail
        ? _c("ComposeEmail", {
            attrs: {
              emails: _vm.selectedEmails,
              signature: "",
              sendAsStudio: "",
              tinyMCE: "",
              user: _vm.$page.props.auth.user,
              errors: _vm.errors,
            },
            on: {
              success: function ($event) {
                return _vm.emailSuccess()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.composeEmail = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }